<template>
  <b-card no-body class="template-card" @click="$emit('click')">
    <div class="template-card__inner">
      <b-img-lazy
        center
        :src="template.icon && template.icon.url"
        class="template-card__icon"
      ></b-img-lazy>
      <div class="template-card__text">
        <div class="template-card__title">{{ template.label }}</div>
        <div class="template-card__desc">{{ template.description }}</div>
      </div>
    </div>
  </b-card>
</template>
<script>
export default {
  props: {
    template: {
      type: Object,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
/* Fluid square card: fills its grid column (never a fixed pixel width that would
 * overflow and overlap neighbours), capped so it matches the current desktop
 * size on wide screens. aspect-ratio keeps it square as the column width flexes. */
.template-card {
  /* Slightly narrower than the column + centered, so there is always a clear
   * horizontal gap between cards as they compact, independent of grid gutters. */
  width: calc(100% - 1rem);
  max-width: 342px;
  margin: 0 auto;
  aspect-ratio: 1 / 1;
  cursor: pointer;

  &:hover {
    background: #eaf3ff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 25px #00429d0d;
  }
}

.template-card__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  padding: 1rem;
  overflow: hidden;
}

.template-card__icon {
  width: 55%;
  max-width: 192px;
  height: auto;
  aspect-ratio: 1 / 1;
  object-fit: contain;
}

.template-card__text {
  margin-top: 0.5rem;
  width: 100%;
  min-width: 0;
}

.template-card__title {
  font-weight: bold;
}

.template-card__desc {
  color: #6c757d;
}

/* Phones: compact horizontal "icon : name" rows (like the Select Template list),
 * with side margins so the cards don't touch the screen edges. */
@media (max-width: 575.98px) {
  .template-card {
    width: auto;
    max-width: none;
    height: auto;
    aspect-ratio: auto;
    margin: 0 1.25rem;
  }

  .template-card__inner {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    padding: 0.65rem 0.9rem;
  }

  .template-card__icon {
    width: 44px;
    max-width: 44px;
    height: 44px;
    aspect-ratio: auto;
    margin: 0 0.85rem 0 0 !important;
    flex: 0 0 auto;
  }

  .template-card__text {
    margin-top: 0;
  }

  .template-card__title {
    font-size: 1rem;
    margin-bottom: 0.1rem;
  }

  .template-card__desc {
    font-size: 0.85rem;
    line-height: 1.2;
  }
}
</style>
